// scopedFetch — fetch wrapper that opportunistically attaches whichever
// scoped credential is in sessionStorage for this page:
//   - byod_processing_key → X-Processing-Key header (recording device)
//   - byod_viewer_token   → X-Viewer-Token header  (viewer device)
// Only one of the two is ever present at a time. Used by panels that may
// render in the TA dashboard (cookie auth), the BYOD recording page
// (processing key), or the viewer page (viewer token).
//
// The server validates that the credential matches the device id in the
// URL — see wrappers.verify_login(allow_key_scoped=True,
// allow_viewer_token=True) on the backend.
export function scopedFetch(input, init = {}) {
    let procKey = null;
    let viewerTok = null;
    try {
        if (typeof sessionStorage !== 'undefined') {
            procKey = sessionStorage.getItem('byod_processing_key');
            viewerTok = sessionStorage.getItem('byod_viewer_token');
        }
    } catch (e) { /* ignore */ }

    const headers = new Headers(init.headers || {});
    if (procKey && !headers.has('X-Processing-Key')) {
        headers.set('X-Processing-Key', procKey);
    }
    if (viewerTok && !headers.has('X-Viewer-Token')) {
        headers.set('X-Viewer-Token', viewerTok);
    }

    return fetch(input, {
        credentials: 'include',
        ...init,
        headers,
    });
}
